/**
 * Menu column 1 in the footer
 */

// Import statements
import React from "react"
import {graphql, useStaticQuery} from "gatsby";
import NavPills from "../common/nav-pills";

/**
 * Define the FooterColumnOneMenu component
 * @param menu
 * @returns {JSX.Element}
 * @constructor
 */
const FooterColumnOneMenu = ({menu}) => {

    // query col_1 menu
    const col_1_menu_data = useStaticQuery(
        graphql`
          query {
            wpMenu(locations: {eq: FOOTER_1_NAVIGATION}) {
              id
              name
              menuItems {
                nodes {
                  parentId
                  label
                  path
                  childItems {
                    nodes {
                      path
                      label
                    }
                  }
                }
              }
            }
          }
        `
    );

    // get parent items of the col_1 menu
    const col_1_menu = col_1_menu_data.wpMenu.menuItems.nodes
        ? col_1_menu_data.wpMenu.menuItems.nodes.filter(menuItem => menuItem.parentId === null)
        : null

    // return the col_1 menu
    return (
        <section className="col-md-2 col-sm-4 col-xs-6">
            <h3>{col_1_menu_data.wpMenu.name}</h3>
            <NavPills menu={col_1_menu} ul_class="nav nav-pills flex-column"/>
        </section>

    )
}

/**
 * Export the menu
 */
export default FooterColumnOneMenu